import React, { Component, useEffect, useState } from "react";
import "./SignUp.scss";
import SocialLogin from "../SocialLogin/SocialLogin";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { signUp, sendOTP, verifyOTP, setOTPSent } from "../../../actions/authAction";
import { ReactComponent as EyeClose } from "../../../assets/svg/password-hide.svg";
import { ReactComponent as EyeOpen } from "../../../assets/svg/password-show.svg";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
// import { ReactComponent as EmailLink } from "../../../assets/svg/email-link.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { isMobile } from "react-device-detect";
import { Redirect } from "react-router-dom";
class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            userName: "",
            password: "",
            confirmPassword: "",
            showPassword: false,
            showConfirmPassword: false,
            otp: "",
            verifyingOtp: false,
        };
    }

    componentDidMount() {
        document.title = "Login to Radarr - Best Social Listening Platform";
        this.changeEmail();
    }

    onSignUp = () => {
        const email = this.state.email;
        const password = this.state.password;
        const confirmPassword = this.state.confirmPassword;
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#%&*])(?=.{8,})/;
        let specialCharacter = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
        const emailPattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (email === "") {
            toast.error("Please enter a valid company email");
            return;
        } else if (!emailPattern.test(email)) {
            toast.error("Please enter a valid company email");
        } else if (password === "") {
            toast.error("Please enter a password");
            return;
        } else if (confirmPassword === "") {
            toast.error("Please confirm your password");
            return;
        } else if (password.length < 8) {
            toast.error("Password criteria is not fullfilled.");
            return;
        } else if (password.length > 30) {
            toast.error("Password criteria is not fullfilled.");
            return;
        } else if (!specialCharacter.test(password)) {
            toast.error("Password criteria is not fullfilled.");
            return;
        } else if (password !== confirmPassword) {
            toast.error("Passwords do not match.");
            return;
        } else if (password === email) {
            toast.error("Password criteria is not fullfilled.");
            return;
        } else {
            let param = {};
            param["email"] = email;
            this.props
                .sendOTP(param)
                .then((res) => {
                    if (res?.value?.data?.status === "error") {
                        if (res?.value?.data?.message === "You already have an active account with this email.") {
                            toast.error("You already have an account on Radarr. Please sign in with your email address.");
                            this.props.history.push("/signin");
                        } else if (res?.value?.data?.message) toast.error(res.value.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    setEmail = (email) => {
        this.setState({ email });
    };
    setPassword = (password) => {
        this.setState({ password });
    };
    setConfirmPassword = (confirmPassword) => {
        this.setState({ confirmPassword });
    };
    // setUserName = (userName) => {
    //     this.setState({ userName });
    // };
    showPassword = () => {
        if (this.props.otpSent) return;
        this.setState({ showPassword: !this.state.showPassword });
    };
    showConfirmPassword = () => {
        if (this.props.otpSent) return;
        this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
    };

    verifyOTP = () => {
        let param = {};
        if (this.state.otp === "") {
            toast.error("Please enter the OTP sent to your email.");
            return;
        }
        this.setState({ verifyingOtp: true });
        param["email"] = this.state.email;
        param["token"] = this.state.otp;
        this.props
            .verifyOTP(param)
            .then((res) => {
                if (res?.value?.status === "success" && res?.value?.data?.message === "email has been verified successfully.") {
                    let param = {};
                    param["email"] = this.state.email;
                    param["password"] = this.state.password;
                    param["confirm_password"] = this.state.confirmPassword;
                    this.props.signUp(param).then((res) => {
                        // console.log(res);
                        this.setState({ verifyingOtp: false });
                    });
                } else {
                    this.setState({ verifyingOtp: false });
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ verifyingOtp: false });
            });
    };

    changeEmail = () => {
        this.props.setOTPSent();
        this.setState({ password: "", confirmPassword: "", otp: "" });
    };

    render() {
        let otpSent = this.props.otpSent;

        return (
            <div className="signUp">
                <div className="header__container">
                    <h2 className="form__heading">Start your free 7-day trial</h2>
                    <p className="form__para">No credit card needed</p>
                </div>
                <div className={`signUp__form ${otpSent ? "signUp__form-signed" : ""}`}>
                    <label className="form__label">Company Email*</label>
                    <input
                        placeholder="Enter Company Email"
                        value={this.state.email}
                        disabled={otpSent}
                        autoComplete="none"
                        onChange={(ev) => this.setEmail(ev.target.value)}></input>
                    {!otpSent ? (
                        <p className="input-message">Verification code will be sent to your email</p>
                    ) : (
                        <p className="input-message input-message-right">
                            Entered a wrong email? <span onClick={this.changeEmail}>Change Email</span>
                        </p>
                    )}
                    <label className="form__label">Password*</label>
                    <div className="password__field-wrap">
                        <Popup
                            trigger={
                                <input
                                    disabled={otpSent}
                                    placeholder="Enter Password"
                                    type={this.state.showPassword ? "text" : "password"}
                                    className="password__inputField"
                                    value={this.state.password}
                                    onChange={(ev) => this.setPassword(ev.target.value)}
                                />
                            }
                            header="Your password needs to be:"
                            content="Between 8 and 30 characters in length.
                                    Use at least one special character (EG -!#$%&'()*+,-./:;<=>?@[\]^_`{|}~).
                                    Should be different from your email id and username."
                            position={isMobile ? "top center" : "left center"}
                            on="focus"
                            inverted
                        />
                        {
                            <span className="eye__btn" onClick={() => this.showPassword()}>
                                {this.state.showPassword ? (
                                    <EyeOpen className="eye__icon" title="Hide Password" />
                                ) : (
                                    <EyeClose className="eye__icon" title="Show Password" />
                                )}
                            </span>
                        }
                    </div>
                    <label className="form__label">Confirm Password*</label>
                    <div className="password__field-wrap">
                        <Popup
                            trigger={
                                <input
                                    disabled={otpSent}
                                    placeholder="Confirm Password"
                                    type={this.state.showConfirmPassword ? "text" : "password"}
                                    className="password__inputField"
                                    value={this.state.confirmPassword}
                                    onChange={(ev) => this.setConfirmPassword(ev.target.value)}
                                />
                            }
                            header="Password hint"
                            content="Between 8 and 30 characters in length.
                                     Use at least a special character (EG -!#$%&'()*+,-./:;<=>?@[\]^_`{|}~).
                                     Should be different from your email id and username."
                            position={isMobile ? "top center" : "left center"}
                            on="focus"
                            inverted
                        />
                        {
                            <span className="eye__btn" onClick={this.showConfirmPassword}>
                                {this.state.showConfirmPassword ? (
                                    <EyeOpen className="eye__icon" title="Hide Password" />
                                ) : (
                                    <EyeClose className="eye__icon" title="Show Password" />
                                )}
                            </span>
                        }
                    </div>
                    {!otpSent && (
                        <button disabled={otpSent} className="signUp__btn" onClick={this.onSignUp}>
                            <span>{!this.props.signUpLoading ? "Sign Up" : <Loader inverted active size="small" />}</span>
                        </button>
                    )}
                    {otpSent && (
                        <>
                            <label className="form__label verification">Verification Code*</label>
                            <input
                                type="number"
                                className="verification"
                                placeholder="Enter Code"
                                onChange={(ev) => this.setState({ otp: ev.target.value })}
                                value={this.state.otp}
                            />
                            <p className="input-message input-message-flex">
                                Enter 6 digit verification code you received in your email
                                <ResendCode onSignUp={this.onSignUp} />
                            </p>
                            <button className="signUp__btn" onClick={this.verifyOTP}>
                                <span>{this.state.verifyingOtp ? <Loader inverted active size="small" /> : "Confirm"}</span>
                            </button>
                        </>
                    )}
                </div>
                {!otpSent && (
                    <div className="socialLogin__wrapper">
                        <SocialLogin routeTo={"/signin"} />
                    </div>
                )}
                {!otpSent && (
                    <div className="privacy__policy">
                        <a href="https://www.radarr.com/terms-of-use/" target="_blank" rel="noreferrer">
                            <span className="privacy__text">Terms and Conditions </span>
                        </a>{" "}
                        <span className="privacy__text-separate"> | </span>{" "}
                        <a href="https://www.radarr.com/privacypolicy" target="_blank" rel="noreferrer">
                            {" "}
                            <span className="privacy__text">Privacy Policy </span>
                        </a>
                    </div>
                )}
                {this.props.emailVerified && <Redirect to="/home" />}
            </div>
        );
    }
}

const ResendCode = ({ onSignUp }) => {
    const [time, updateTime] = useState(30);

    useEffect(() => {
        setTimeout(() => updateTime(time - 1), 1000);
    }, []);

    useEffect(() => {
        if (time > 0) {
            setTimeout(() => updateTime(time - 1), 1000);
        } else {
            updateTime(0);
        }
    }, [time]);

    if (time === 0) return <span onClick={onSignUp}>Resend code</span>;
    else return <span>Resend in... {time} secs</span>;
};

const mapStateToProps = (state) => {
    return {
        signUpLoading: state.authReducer.signUpLoading,
        otpSent: state.authReducer.otpSent,
        emailVerified: state.authReducer.emailVerified,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signUp: (data) => dispatch(signUp(data)),
        sendOTP: (data) => dispatch(sendOTP(data)),
        verifyOTP: (data) => dispatch(verifyOTP(data)),
        setOTPSent: () => dispatch(setOTPSent()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
